var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sui-input',{ref:"field",attrs:{"maxlength":4,"value":_vm.value},on:{"keypress":function($event){return _vm.onlyNumber($event)}},nativeOn:{"input":function($event){return _vm.onChange($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }